import { FormControl, FormLabel } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';
import { DateRangeInput } from '../DateRangeInput/DateRangeInput';

export const DateRangeFilter: FC = () => {
  const { dateRangeStart, dateRangeEnd, setDateRangeStart, setDateRangeEnd } =
    useOrganizationCompliancePage();

  // Set maximum date to today
  const maxDate = dayjs().endOf('day').toDate();

  return (
    <FormControl minWidth="300px">
      <FormLabel>Updated At</FormLabel>
      <DateRangeInput
        endDate={dateRangeEnd}
        inputProps={{ size: 'sm' }}
        maxDate={maxDate}
        placeholder="Select date"
        startDate={dateRangeStart}
        onEndChange={setDateRangeEnd}
        onStartChange={setDateRangeStart}
      />
    </FormControl>
  );
};
